import { render, staticRenderFns } from "./ScoreAnimate.vue?vue&type=template&id=2fed1c93&lang=pug"
import script from "./ScoreAnimate.vue?vue&type=script&lang=js"
export * from "./ScoreAnimate.vue?vue&type=script&lang=js"
import style0 from "./ScoreAnimate.vue?vue&type=style&index=0&id=2fed1c93&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports